import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromTimeTrackings from './time-tracking.reducer';

export const selectTimeTrackingState =
  createFeatureSelector<fromTimeTrackings.TimeTrackingState>(
    fromTimeTrackings.timeTrackingsFeatureKey,
  );

export const selectMyTimeTracking = createSelector(
  selectTimeTrackingState,
  (state) => state.mine,
);

export const selectMyTimeTrackingInProgress = createSelector(
  selectMyTimeTracking,
  (state) => !!state,
);
